
import { defineComponent, toRaw } from "vue"

export default defineComponent({
  data: () => ({
    contacts: toRaw([
      {
        title: "ВОИР",
        items: [
          { value: "https://voir-russia.ru", type: "url" },
          { value: "voir1204@yandex.ru", type: "email" },
          { value: "+7 (958) 146-95-57", type: "tel" },
          { value: "+7 (499) 444-29-04", type: "tel" },
          { label: "Адрес", value: "121059, Москва, Бережковская наб., д. 24, оф. 23" },
        ],
      },
      {
        title: "ВОИРФЕСТ",
        items: [
          { value: "https://voirfest.ru", type: "url" },
          { label: "Общие вопросы", value: "info@voirfest.ru", type: "email" },
          { label: "Пресс-служба", value: "pr@voirfest.ru", type: "email" },
        ],
      },
    ]),
  }),
})
